import React, {Fragment} from 'react'
import styles from './TRouteMeta.scss'
import {Icon} from 'common/Icon'
import moment from 'moment'
import {pl} from 'lib/textUtils'
import {showModal} from 'lib/modalUtils'
import {urls} from 'lib/urls'
import {EDIT_TROUTE_MODAL} from 'common/modals/EditTRouteModal'
import cx from 'classnames'

const PRIVACY_LABELS = {
  '0': 'Public',
  '1': 'Private',
  '2': 'Friends Only'
}

const PRIVACY_ICONS = {
  '0': 'md-globe',
  '1': 'md-eye-off',
  '2': 'md-contact'
}

const TRouteMetaItem = ({children, title, i, onClick}) => (
  <div className={cx(styles.TRouteMetaItem, onClick && styles.clickable)} onClick={onClick}>
    <div className={styles.container} data-tip title={title}>
      <div className={styles.icon}><Icon i={i} size={14} /></div>
      <div className={styles.text}>{children}</div>
    </div>
  </div>
)

export class TRouteMeta extends React.PureComponent {
  render () {
    const {editable, troute: r, objectType} = this.props

    console.log(r)
    return (
      <div className={styles.TRouteMeta}>
        <TRouteMetaItem
          title='Start Location'
          i='md-pin'>
          {r.locality}, {r.administrativeArea}
        </TRouteMetaItem>
        <TRouteMetaItem
          title='Visibility'
          i={PRIVACY_ICONS['' + r.visibility]}
          onClick={editable ? () => showModal(EDIT_TROUTE_MODAL, {troute: r, objectType}) : null}>
          {PRIVACY_LABELS['' + r.visibility]} {r.views && <Fragment>({pl(r.views, 'view')})</Fragment>}
        </TRouteMetaItem>
        <TRouteMetaItem
          title='Date Created'
          i='md-create'>Created {moment(r.createdAt).format('MMM D, YYYY')}
        </TRouteMetaItem>
        {objectType === 'route' && <TRouteMetaItem
          title='Last Updated'
          i='md-sync'>
          Updated {moment(r.updatedAt).format('MMM D, YYYY')}
        </TRouteMetaItem>}
        {objectType === 'trip' && r.gearId !== 0 && r.gearId && // gearId can be zero sometimes?
          <TRouteMetaItem
            title='Gear'
            i='md-bicycle'
            onClick={editable ? () => (window.location.href = urls.gear.show(r.gearId)) : null}>
            {r.gearName}
          </TRouteMetaItem>}
        {r.copiedFromName &&
          <TRouteMetaItem i='md-link'>
            Copy of <a data-tip title={r.copiedFromName} href={r.copiedFromPath}>{r.copiedFromName}</a>
          </TRouteMetaItem>}
      </div>
    )
  }
}
